<template>
    <div class="layout-footer desktop-layout-footer" v-if="isDesktop">
        <div class="footer-view">
            <div class="container-wrapper-footer-left">
                <div class="footer-left-logo_view">
                    <ul class="container-wrapper-list footer-left_ul">
                        <li>
                            <!-- <el-image :src="logo" loading="lazy" class="img" /> -->
                            <!-- <i class="iconfont icon-icon_onlineedit img"></i> -->
                            <nuxt-link :to="localePath('/')" class="logo">
                                <CommonImage src="/assets/images/logo_zh@2x.webp" v-if="isChina" class="img"
                                    :useElementUI="false" />
                                <CommonImage src="/assets/images/logo_en@2x.webp" v-else class="img-en"
                                    :useElementUI="false" />
                            </nuxt-link>
                        </li>
                        <!-- <li class="point">
                        </li>
                        <li class="business-text">
                            {{ t('header_pdfEditOne') }}
                        </li> -->
                    </ul>
                    <p class="hint">{{ $t('bottom_footer_hint') }}</p>
                </div>
                <div class="footer-left-right">
                    <div class="customer-service-email">
                        <i class="iconfont icon-icon_email1"></i>
                        <a href="mailto:<support@pdfone.com>">{{ 'support@pdfone.com' }}</a>
                    </div>
                    <div class="customer-service-email">
                        <i class='iconfont icon-icon_earth'></i>
                        <!-- <span>{{localeName}}</span> -->
                        <span class="language-item" @click="handleLanguageClick(SystemLanguageEnum.ZH)">{{
                            t('bottom_footer_language_zh') }}</span>
                        <div class="language-item-divider" />
                        <span class="language-item" @click="handleLanguageClick(SystemLanguageEnum.EN)">{{
                            t('bottom_footer_language_en') }}</span>
                        <div class="language-item-divider" />
                        <span class="language-item" @click="handleLanguageClick(SystemLanguageEnum.JA)">{{
                            t('bottom_footer_language_ja') }}</span>
                    </div>
                </div>


                <!-- <ul class="container-wrapper-list external_link_view">
                    <li class="cursor">
                        <a href="https://www.doclingo.com/privacy-policy.html" target="_blank">
                            {{ '小红书' }}
                        </a>
                    </li>
                    <li class="cursor">
                        <a href="https://www.doclingo.com/terms-of-service.html" target="_blank">
                            <i class="iconfont icon-icon_twitter"></i>
                        </a>
                    </li>
                </ul> -->

            </div>
            <div class="layout-footer-line" />
            <div class="container-wrapper-footer">
                <ul class="container-wrapper-list on-site" style="margin-top: 30px;">
                    <li v-for="(item, index) in InternalChainList" :key="index" @click="handlerOnSiteClick(item)"
                        class="cursor">
                        {{ item.name }}
                    </li>
                </ul>
                <ul class="container-wrapper-list" style="margin-top: 20px;color:#999;">
                    <li> {{ $t('bottom_footer_copyright') }} </li>
                </ul>
            </div>
        </div>
    </div>

    <div v-else class="mobile-layout-footer">
        <div class="footer-top">
            <nuxt-link :to="localePath('/')" class="logo">
                <CommonImage src="/assets/images/logo_zh@2x.webp" v-if="isChina" class="img" :useElementUI="false" />
                <CommonImage src="/assets/images/logo_en@2x.webp" v-else class="img-en" :useElementUI="false" />
            </nuxt-link>
            <p class="hint">{{ $t('bottom_footer_hint') }}</p>
            <div class="navs">
                <p v-for="(item, index) in InternalChainList" :key="index" @click="handlerOnSiteClick(item)"
                    class="cursor">
                    {{ item.name }}
                </p>
            </div>
        </div>
        <div class="footer-bottom">
            <p>{{ 'support@pdfone.com' }}</p>
            <div class="language-items">
                <span class="language-item" @click="handleLanguageClick(SystemLanguageEnum.ZH)">{{
                    t('bottom_footer_language_zh') }}</span>
                <span class="language-item" @click="handleLanguageClick(SystemLanguageEnum.EN)">{{
                    t('bottom_footer_language_en') }}</span>
                <div class="language-item-divider" />
                <span class="language-item" @click="handleLanguageClick(SystemLanguageEnum.JA)">{{
                    t('bottom_footer_language_ja') }}</span>
            </div>
            <p> {{ $t('bottom_footer_copyright') }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import useBasicStore from '~/store/modules/basic'
import useSystemLaunageStore from '~/store/modules/systemLaunage'
import { SystemLanguageEnum } from '~/types/const'
const viewport = useViewport()
const isDesktop = computed(() => viewport.breakpoint?.value.includes('desktop'))
const logo = new URL('@/assets/images/icon_logo.png', import.meta.url).href
const basicStore = useBasicStore()
const { isChina } = storeToRefs(basicStore)
const systemLanguageStore = useSystemLaunageStore()
const { systemLanguage, languageList } = storeToRefs(systemLanguageStore)
const { t, locale, setLocale } = useI18n()
const localePath = useLocalePath()
const router = useRouter()
const route = useRoute()

const localeName = computed(() => {
    // 优先使用 systemLanguage 中的 name（与 LayoutHeader 下拉框保持一致）
    if (systemLanguage.value?.name) {
        return systemLanguage.value.name
    }

    // 如果 systemLanguage 不存在，尝试从 languageList 中根据当前 locale 查找
    if (languageList.value && locale.value) {
        const currentLang = languageList.value.find(item => item.code === locale.value)
        if (currentLang?.name) {
            return currentLang.name
        }
    }

    // 如果都没有，根据 locale 返回对应的名称
    switch (locale.value) {
        case SystemLanguageEnum.ZH:
            return "简体中文"
        case SystemLanguageEnum.EN:
            return "English"
        case SystemLanguageEnum.JA:
            return "日本語"
        case SystemLanguageEnum.ZH_TW:
            return "繁體中文"
        case SystemLanguageEnum.KO:
            return "한국어"
        case SystemLanguageEnum.HI:
            return "हिंदी"
        case SystemLanguageEnum.DE:
            return "Deutsch"
        case SystemLanguageEnum.AR:
            return "العربية"
        case SystemLanguageEnum.FR:
            return "Français"
        case SystemLanguageEnum.ID:
            return "Indonesia"
        case SystemLanguageEnum.ITB:
            return "Italiano"
        case SystemLanguageEnum.UK:
            return "Українська"
        default:
            return "English"
    }
})

const handleLanguageClick = (language: SystemLanguageEnum) => {
    setLocale(language)
    systemLanguageStore.setLanguage(language)
    useHead({
        htmlAttrs: {
            lang: language
        }
    })
}

const supportImageList = computed(() => {
    if (isChina.value) {
        return [
            { iconfont: "icon-icon_xiaohongshu" },
            { iconfont: "icon-icon_bilibili" },
            { iconfont: "icon-icon_email" }
        ]
    } else {
        return [
            { iconfont: "icon-icon_xiaohongshu" },
            { iconfont: "icon-icon_bilibili" },
            { iconfont: "icon-icon_twitter1" },
            { iconfont: "icon-icon_youtobe" },
            { iconfont: "icon-icon_email" }
        ]
    }
})
const InternalChainList = computed(() => {
    let array = [
        { name: t('header_bolg'), path: "/tutorialConsultation/menuHome", type: 5 },
        { name: t('bottom_footer_service_terms'), path: "/serviceDocs", type: 1 },
        { name: t('bottom_footer_privacy_policy'), path: "/serviceDocs", type: 2 },
        { name: t('bottom_footer_cookie_policy'), path: "/serviceDocs", type: 3 },
        { name: t('bottom_footer_disclaimer'), path: "/serviceDocs", type: 4 }
    ]
    return array
})

// 外链跳转
function handleSupportClick(iconfont: string) {
    switch (iconfont) {
        case "icon-icon_xiaohongshu":
            window.open("https://reurl.cc/ZVL046", "_blank")
            break
        case "icon-icon_bilibili":
            window.location.href = "https://b23.tv/ZtMeRDh"
            break
        case "icon-icon_twitter1":
            window.open("http://twitter.com/doclingopdf", "_blank")
            break
        case "icon-icon_youtobe":
            window.location.href = "https://www.youtube.com/@DoclingoTranslation/videos"
            break
        case "icon-icon_email":
            window.location.href = "mailto:support@doclingo.ai"
            break
        default:
            break
    }
}

// 站内跳转
const handlerOnSiteClick = (item: any) => {
    if(item.type === 5){
        router.push({
            path: `/${locale.value}${item.path}`,
            query: { category: `1` },
        })
    }else{
        router.push({
            path: `/${locale.value}${item.path}`,
            query: { type: `${item.type}` },
        })
    }
    
}
</script>

<style scoped lang="scss">
@use "./index.scss" as *;
@use "./mobile.scss" as *;
</style>